import { useSyncExternalStore } from 'react';

/**
 * Whether the reader's Stats drawer is open. A store, not state in the menu
 * that opens it: the menu closes (and its buttons unmount) the moment an
 * entry is chosen, and the drawer has to outlive it.
 */
let open = false;
const listeners = new Set<() => void>();

export function setIssueStatsOpen(next: boolean): void {
	if (open === next) {
		return;
	}
	open = next;
	listeners.forEach((listener) => listener());
}

const subscribe = (listener: () => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export function useIssueStatsOpen(): boolean {
	return useSyncExternalStore(
		subscribe,
		() => open,
		() => false,
	);
}
